import {
  MATCH_TIE_ERROR,
  MAX_SCORE_ERROR,
  MAX_SCORE_POINTS,
  MIN_SCORE_ERROR,
  MIN_SCORE_POINTS,
  MIN_SCORE_POINTS_2,
  TEAMS_SCORE_ERROR,
} from '@/constants/Common'
import { FIELD_REQUIRED, MIN_SCORE_ERROR_2, SCORE_ERROR, TEAM1_REQUIRED, TYPE_DATE } from '@/constants/MessageConstants'
import moment from 'moment'
import * as Yup from 'yup'

const wrongMatchResult1 = ['TIE']
const wrongMatchResult2 = ['WIN-LOST', 'LOST-WIN', 'TIE-TIE']
const wrongMatchResult3 = [
  'WIN-LOST-TIE',
  'WIN-TIE-LOST',
  'LOST-WIN-TIE',
  'LOST-TIE-WIN',
  'TIE-WIN-LOST',
  'TIE-LOST-WIN',
  'TIE-TIE-TIE',
]
const wrongMatchResult4 = [
  'WIN-LOST-WIN-LOST',
  'LOST-WIN-LOST-WIN',
  'WIN-WIN-LOST-LOST',
  'LOST-LOST-WIN-WIN',
  'WIN-LOST-LOST-WIN',
  'LOST-WIN-WIN-LOST',
  'WIN-LOST-TIE-TIE',
  'WIN-TIE-TIE-LOST',
  'LOST-WIN-TIE-TIE',
  'LOST-TIE-TIE-WIN',
  'TIE-TIE-WIN-LOST',
  'TIE-TIE-LOST-WIN',
  'TIE-WIN-LOST-TIE',
  'TIE-LOST-WIN-TIE',
  'TIE-TIE-TIE-TIE',
]
const wrongMatchResult5 = [
  'WIN-LOST-WIN-LOST-TIE',
  'LOST-WIN-LOST-WIN-TIE',
  'WIN-WIN-LOST-LOST-TIE',
  'LOST-LOST-WIN-WIN-TIE',
  'WIN-LOST-LOST-WIN-TIE',
  'LOST-WIN-WIN-LOST-TIE',
  'TIE-WIN-LOST-WIN-LOST',
  'TIE-LOST-WIN-LOST-WIN',
  'TIE-WIN-WIN-LOST-LOST',
  'TIE-LOST-LOST-WIN-WIN',
  'TIE-WIN-LOST-LOST-WIN',
  'TIE-LOST-WIN-WIN-LOST',
  'WIN-LOST-TIE-WIN-LOST',
  'LOST-WIN-TIE-LOST-WIN',
  'WIN-WIN-TIE-LOST-LOST',
  'LOST-LOST-TIE-WIN-WIN',
  'WIN-LOST-TIE-LOST-WIN',
  'LOST-WIN-TIE-WIN-LOST',
  'WIN-TIE-LOST-WIN-LOST',
  'LOST-TIE-WIN-LOST-WIN',
  'WIN-TIE-WIN-LOST-LOST',
  'LOST-TIE-LOST-WIN-WIN',
  'WIN-TIE-LOST-LOST-WIN',
  'LOST-TIE-WIN-WIN-LOST',
  'WIN-LOST-WIN-TIE-LOST',
  'LOST-WIN-LOST-TIE-WIN',
  'WIN-WIN-LOST-TIE-LOST',
  'LOST-LOST-WIN-TIE-WIN',
  'WIN-LOST-LOST-TIE-WIN',
  'LOST-WIN-WIN-TIE-LOST',
  'WIN-TIE-TIE-TIE-LOST',
  'LOST-TIE-TIE-TIE-WIN',
  'TIE-LOST-TIE-WIN-TIE',
  'TIE-TIE-LOST-WIN-TIE',
  'TIE-LOST-WIN-TIE-TIE',
  'TIE-WIN-TIE-LOST-TIE',
  'TIE-TIE-WIN-LOST-TIE',
  'TIE-WIN-LOST-TIE-TIE',
  'TIE-TIE-TIE-TIE-TIE',
]

const minPoints = (value: any) => {
  if (value?.[0]?.team1 >= 0 && value?.[0]?.team2 >= 0) {
    if (!(value?.[0]?.team1 >= MIN_SCORE_POINTS || value?.[0]?.team2 >= MIN_SCORE_POINTS)) {
      return false
    }
  }
  return true
}

const checkScores = (value: any) => {
  let flag = true
  for (const scores of value) {
    if (scores?.team1 === 0 && scores?.team2 === 0) {
      flag = false
      break
    }
  }
  return flag
}

const checkStatus = (value: any) => {
  let status = ''
  for (const scores of value) {
    const gameStatus = scores?.team1 > scores?.team2 ? 'WIN' : scores?.team1 < scores?.team2 ? 'LOST' : 'TIE'
    status = status ? `${status}-${gameStatus}` : gameStatus
  }

  if (value?.[0]?.team1 && value?.[0]?.team2) {
    if (value?.length === 1) {
      if (wrongMatchResult1.includes(status)) return false
    }
  }

  if (value?.length === 2) {
    if (wrongMatchResult2.includes(status)) return false
  }

  if (value?.length === 3) {
    if (wrongMatchResult3.includes(status)) return false
  }

  if (value?.length === 4) {
    if (wrongMatchResult4.includes(status)) return false
  }

  if (value?.length === 5) {
    if (wrongMatchResult5.includes(status)) return false
  }
  return true
}

const TeamValidationSchema = Yup.object().shape({
  game1: Yup.string().required(FIELD_REQUIRED),
  player1: Yup.string().required(TEAM1_REQUIRED),
})

const AddMatchValidationSchema = Yup.object().shape({
  matches: Yup.array().of(
    Yup.object().shape({
      team1: TeamValidationSchema,
      team2: TeamValidationSchema,
    })
  ),
})

export const UpdateScoreSchema = Yup.object().shape({
  matchDate: Yup.date()
    .typeError(TYPE_DATE)
    .required(TYPE_DATE)
    .test('checkDate2', '', function () {
      const { path, parent, createError } = this
      if (parent.minDate.getTime() > new Date().getTime()) {
        return createError({
          path,
          message: `Add a date on or after the start date:  ${moment(parent.minDate).format(
            'MMMM DD, YYYY, hh:mm A'
          )}.`,
        })
      }
      return true
    }),
  winner: Yup.string(),
  games: Yup.array()
    .of(
      Yup.object().shape({
        team1: Yup.number()
          .typeError(SCORE_ERROR)
          .required(SCORE_ERROR)
          .min(MIN_SCORE_POINTS_2, MIN_SCORE_ERROR_2)
          .max(MAX_SCORE_POINTS, MAX_SCORE_ERROR),
        team2: Yup.number()
          .typeError(SCORE_ERROR)
          .required(SCORE_ERROR)
          .min(MIN_SCORE_POINTS_2, MIN_SCORE_ERROR_2)
          .max(MAX_SCORE_POINTS, MAX_SCORE_ERROR),
      })
    )
    .test('minPoints', MIN_SCORE_ERROR, (value) => minPoints(value))
    .test('checkMatchStatus', MATCH_TIE_ERROR, (value) => checkStatus(value))
    .test('checkMatchScores', TEAMS_SCORE_ERROR, (value) => checkScores(value)),
})

export default AddMatchValidationSchema
